module.exports = __webpack_public_path__ + "static/media/icon_cleaning.a526a412.svg";